var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 6.6665H10.0001C8.15841 6.6665 6.66675 8.15817 6.66675 9.99984V39.9998C6.66675 41.8415 8.15841 43.3332 10.0001 43.3332H40.0001C41.8417 43.3332 43.3334 41.8415 43.3334 39.9998V9.99984C43.3334 8.15817 41.8417 6.6665 40.0001 6.6665ZM25.0001 33.9665C25.0001 36.9282 23.1834 38.5882 20.1667 38.5882C17.1867 38.5882 15.2884 36.8465 15.2884 34.0298H18.5167C18.5251 35.0748 19.1484 35.7348 20.1117 35.7348C21.1017 35.7348 21.6334 35.1115 21.6334 33.9382V24.9965H25.0001V33.9665ZM34.1351 38.5882C30.7867 38.5882 28.6801 37.0115 28.6234 34.4615H31.8334C31.9151 35.4248 32.8767 36.0382 34.2717 36.0382C35.5284 36.0382 36.3917 35.4332 36.3917 34.5615C36.3917 33.8282 35.8134 33.4332 34.3001 33.1315L32.5584 32.7832C30.1367 32.3248 28.8901 31.0048 28.8901 28.9232C28.8901 26.3365 30.9634 24.6398 34.1534 24.6398C37.2534 24.6398 39.3984 26.3182 39.4534 28.7665H36.3451C36.2717 27.8315 35.3817 27.1798 34.1967 27.1798C33.0151 27.1798 32.2367 27.7398 32.2367 28.6198C32.2367 29.3448 32.8234 29.7665 34.2167 30.0415L35.9201 30.3715C38.5351 30.8765 39.7084 32.0582 39.7084 34.1582C39.7101 36.9198 37.6017 38.5882 34.1351 38.5882Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/Express.96a655ad8ab717d2fa7fbb43d8dbe621.svg";
export { ForwardRef as ReactComponent };